import { useSetting } from '../../../util/useSetting';

export default function ClassSelectionPopup(props) {
    const { fontSize } = useSetting();
    return (
        <div className='fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[99] rounded-[16px]' style={{fontSize}}>
            <div className='px-[64px] max-w-[80%] bg-white flex flex-col items-center' style={{
                backgroundImage: `url(/secondary/bg10.png)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
                borderRadius: '16px',
            }}>
                <div className='text-[#6E0526] w-full flex items-center text-center justify-center font-bold py-[16px]' style={{ fontSize: fontSize+4, borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
                      確認刪除？
                </div>
                <div className='text-black w-full flex items-center text-center justify-center py-[8px]' style={{ fontSize: fontSize }}>
                      此操作無法撤銷。
                </div>
      
                <div className='flex w-full flex-row items-center justify-center py-[16px] gap-[16px] noto-san-hk mb-[24px]'>
                    <button
                        className='px-[16px] py-[8px] text-black rounded-[8px] font-bold w-[190px] rounded-full' style={{background: 'linear-gradient(to bottom, #BEBEBE90, #fff)'}}
                        onClick={() => {
                            props.onCancel && props.onCancel();
                        }}
                    >
                        返回
                    </button>
                    <button
                        className='px-[16px] py-[8px] text-white text-white rounded-[8px] font-bold w-[190px] rounded-full' style={{background: 'linear-gradient(to right, #59081A, #D16963)'}}
                        onClick={() => 
                            props.onDelete && props.onDelete()
                        }
                    >
                        刪除
                    </button>
                </div>
            </div>
        </div>
    );
}